import { SelectAvailability } from "./select-availability.model";
import { SelectImage } from "./select-image.model";

export class SelectPhone extends SelectImage {
  mask: string | null = null;
  dialCode: string | null = null;
  availability: SelectAvailability | null = null
}